import { useCallback, useRef } from 'react';
export const useAppLoadEnded = (actions) => {
    const loadEnded = useRef(false);
    const appLoadEnded = useCallback(() => {
        if (actions?.appLoadEnded && !loadEnded.current) {
            actions.appLoadEnded();
            loadEnded.current = true;
        }
    }, [actions?.appLoadEnded, loadEnded]);
    return { appLoadEnded };
};
//# sourceMappingURL=use-app-loaded.js.map